import { motion } from 'framer-motion';
import { Baby } from 'lucide-react';

interface GenderFilterProps {
  selectedGender: 'boys' | 'girls' | null;
  onGenderSelect: (gender: 'boys' | 'girls' | null) => void;
}

export default function GenderFilter({ selectedGender, onGenderSelect }: GenderFilterProps) {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-medium text-gray-700 mb-3">Filter by Gender</h3>
      <div className="flex gap-4">
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onGenderSelect('boys')}
          className={`flex items-center gap-2 px-6 py-3 rounded-lg ${
            selectedGender === 'boys'
              ? 'bg-blue-600 text-white'
              : 'bg-white text-gray-600 hover:bg-blue-50'
          }`}
        >
          <Baby size={20} />
          Boys
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => onGenderSelect('girls')}
          className={`flex items-center gap-2 px-6 py-3 rounded-lg ${
            selectedGender === 'girls'
              ? 'bg-pink-600 text-white'
              : 'bg-white text-gray-600 hover:bg-pink-50'
          }`}
        >
          <Baby size={20} />
          Girls
        </motion.button>
      </div>
    </div>
  );
}